<!-- 成功案列 -->
<template>
    <div class="warp caseWarp">
        <div class="caseBanner">
            <img src="../assets/images/case01.jpg"/>
        </div>
        <div class="tabs">
            <van-tabs v-model="active">
                <van-tab @click="changeTab(1)" title="游戏系统">
<!--                    <ul>-->
<!--                        <li>-->
<!--                            <div>-->
<!--                                <img src="../assets/images/cese02.jpg"/>-->
<!--                                <span>租号铺</span>-->
<!--                                <i></i>-->
<!--                            </div>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <div>-->
<!--                                <img src="../assets/images/cese03.jpg"/>-->
<!--                                <span>美人转</span>-->
<!--                                <i></i>-->
<!--                            </div>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <div>-->
<!--                                <img src="../assets/images/cese04.jpg"/>-->
<!--                                <span>租号铺</span>-->
<!--                                <i></i>-->
<!--                            </div>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <div>-->
<!--                                <img src="../assets/images/cese05.jpg"/>-->
<!--                                <span>美人转</span>-->
<!--                                <i></i>-->
<!--                            </div>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <div>-->
<!--                                <img src="../assets/images/cese02.jpg"/>-->
<!--                                <span>租号铺</span>-->
<!--                                <i></i>-->
<!--                            </div>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <div>-->
<!--                                <img src="../assets/images/cese03.jpg"/>-->
<!--                                <span>美人转</span>-->
<!--                                <i></i>-->
<!--                            </div>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <div>-->
<!--                                <img src="../assets/images/cese04.jpg"/>-->
<!--                                <span>租号铺</span>-->
<!--                                <i></i>-->
<!--                            </div>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <div>-->
<!--                                <img src="../assets/images/cese05.jpg"/>-->
<!--                                <span>美人转</span>-->
<!--                                <i></i>-->
<!--                            </div>-->
<!--                        </li>-->
<!--                    </ul>-->
                    <ul>
                        <li v-for="(item,index) of list.one" :key="index">
                            <div>
                                <img :src="url + item.imgUrl"/>
                                <span>{{item.name}}</span>
                                <i></i>
                            </div>
                        </li>
                    </ul>
                </van-tab>
                <van-tab @click="changeTab(2)" title="电商系统">
                    <ul>
                        <li v-for="(item,index) of list.two" :key="index">
                            <div>
                                <img :src="url + item.imgUrl"/>
                                <span>{{item.name}}</span>
                                <i></i>
                            </div>
                        </li>
                    </ul>
                </van-tab>
                <van-tab @click="changeTab(3)" title="直播系统">
                    <ul>
                        <li v-for="(item,index) of list.three" :key="index">
                            <div>
                                <img :src="url + item.imgUrl"/>
                                <span>{{item.name}}</span>
                                <i></i>
                            </div>
                        </li>
                    </ul>
                </van-tab>
                <van-tab @click="changeTab(4)" title="营销系统">
                    <ul>
                        <li v-for="(item,index) of list.four" :key="index">
                            <div>
                                <img :src="url + item.imgUrl"/>
                                <span>{{item.name}}</span>
                                <i></i>
                            </div>
                        </li>
                    </ul>
                </van-tab>
            </van-tabs>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import {Tab, Tabs} from "vant";
import {getCase} from '@/api/other.js'
import config from "../../config/config";

Vue.use(Tab).use(Tabs);
export default {
    name: "",

    data() {
        return {
            active: 0,
            url: config.baseUrl.pro,
            list: {
                one: [],
                two: [],
                three: [],
                four: [],
            }
        };
    },
    mounted() {
    },
    created() {
        this.changeTabOne(1);
        this.changeTabTwo(2);
        this.changeTabThree(3);
        this.changeTabFour(4);
    },

    methods: {
        changeTabOne(index) {
            getCase({type: index})
                .then(res => {
                    this.list.one = res;
                })
                .catch(err => {
                    // this.$Message.error(err);
                })
        },
        changeTabTwo(index) {
            getCase({type: index})
                .then(res => {
                    this.list.two = res;
                })
                .catch(err => {
                    // this.$Message.error(err);
                })
        },
        changeTabThree(index) {
            getCase({type: index})
                .then(res => {
                    this.list.three = res;
                })
                .catch(err => {
                    // this.$Message.error(err);
                })
        },
        changeTabFour(index) {
            getCase({type: index})
                .then(res => {
                    this.list.four = res;
                })
                .catch(err => {
                    // this.$Message.error(err);
                })
        },
    }
};
</script>
<style lang='less' scoped>
    .warp {
        background-color: #ecedf0;
        padding-top: 1.45rem;
        box-sizing: border-box;
        padding-bottom: 1.2rem;

        .caseBanner {
            img {
                width: 100%;
            }
        }

        ul {
            padding: 0.2rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-direction: row;
            flex-wrap: wrap;

            li {
                width: 50%;
                padding: 0.2rem;

                div {
                    border-radius: 0.1rem;
                    background-color: #fff;
                    text-align: center;
                    overflow: hidden;

                    img {
                        height: 2.4rem;
                        display: block;
                        margin: 0.3rem auto;
                    }

                    span {
                        font-size: 0.38rem;
                        color: #666666;
                    }

                    i {
                        height: 0.06rem;
                        width: 0.5rem;
                        background-color: #666;
                        display: block;
                        margin: 0.2rem auto 0.6rem;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/case.vue